import { FETCH_REGIMEN, FETCH_REGIMEN_SUCCESS, FETCH_REGIMEN_ERROR } from "../actions/catalogos/regimenFiscalAction";

const initialState = {
    loading: true,
    regimenes: [],
    error: ''
};


const regimenFiscalReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REGIMEN:
            return {
                ...state,
                loading: true
            };
        case FETCH_REGIMEN_SUCCESS:
            return {
                loading: false,
                regimenes: action.payload,
                error: ''
            };
        case FETCH_REGIMEN_ERROR:
            return {
                loading: false,
                regimenes: [],
                error: action.payload
            };
        default:
            return state;
    }
};

export default regimenFiscalReducer;